<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">Contents</p>
<p class="toc"><a href="#/html/9780226848969_07_ch0">DRAMATIS PERSONAE</a></p>
<p class="toc"><a href="#/html/9780226848969_08_ch1">I</a></p>
<p class="toc"><a href="#/html/9780226848969_09_ch2">II</a></p>
<p class="toc"><a href="#/html/9780226848969_10_ch3">III</a></p>
<p class="toc"><span href="#/html/9780226848969_11_ch4" title="Link target outside of Sample">IV</span></p>
<p class="toc"><span href="#/html/9780226848969_12_ch5" title="Link target outside of Sample">V</span></p>
<p class="toc"><span href="#/html/9780226848969_13_ch6" title="Link target outside of Sample">VI</span></p>
<p class="toc"><span href="#/html/9780226848969_14_ch7" title="Link target outside of Sample">VII</span></p>
<p class="toc"><span href="#/html/9780226848969_15_ch8" title="Link target outside of Sample">VIII</span></p>
<p class="toc"><span href="#/html/9780226848969_16_ch9" title="Link target outside of Sample">IX</span></p>
<p class="toc"><span href="#/html/9780226848969_17_ch10" title="Link target outside of Sample">X</span></p>
<p class="toc"><span href="#/html/9780226848969_18_ch11" title="Link target outside of Sample">XI</span></p>
<p class="toc"><span href="#/html/9780226848969_19_ch12" title="Link target outside of Sample">XII</span></p>
<p class="toc"><span href="#/html/9780226848969_20_ch13" title="Link target outside of Sample">XIII</span></p>
<p class="toc"><span href="#/html/9780226848969_21_ch14" title="Link target outside of Sample">XIV</span></p>
<p class="toc"><span href="#/html/9780226848969_22_ch15" title="Link target outside of Sample">XV</span></p>
<p class="toc"><span href="#/html/9780226848969_23_ch16" title="Link target outside of Sample">XVI</span></p>
<p class="toc"><span href="#/html/9780226848969_24_ch17" title="Link target outside of Sample">XVII</span></p>
<p class="toc"><span href="#/html/9780226848969_25_ch18" title="Link target outside of Sample">XVIII</span></p>
<p class="toc"><span href="#/html/9780226848969_26_pos" title="Link target outside of Sample">POSTSCRIPT</span></p>
<p class="toc"><span href="#/html/9780226848969_27_not" title="Link target outside of Sample">Note</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226848969_07a_toc.vue?09bdf15e